import {
  PatchUserRequestBodyType,
  PatchUserResponseBodyType,
} from "@intelligems/ig-types/functions/users/patch-user";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { userKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const patchUser = async (data: ApiRequest<PatchUserRequestBodyType>) => {
  const resp = await api.patch<
    PatchUserResponseBodyType,
    PatchUserRequestBodyType
  >(`/v2/users/${data.body.user.id}`, {
    user: data.body.user,
  });
  return resp.data;
};

export const usePatchUser = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PatchUserResponseBodyType,
    Error,
    ApiRequest<PatchUserRequestBodyType>,
    any
  >({
    mutationKey: ["patchUser"],
    mutationFn: async (data: ApiRequest<PatchUserRequestBodyType>) => {
      return patchUser(data);
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: userKeys.all });
    },
  });
};
